import React from 'react'
import { Link, useParams } from 'react-router-dom'
import styled from 'styled-components/macro'
import { BodyText, H1 } from 'src/branding/typography'
import FadeIn from 'src/components/styled/FadeIn'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import useIsBlocked from 'src/hooks/useIsBlocked'

/**
 * Placeholder until Step 12+ section logging screens land.
 * Keeps six-section home links from 404ing.
 */
const FoodSafetySectionPlaceholder = () => {
  const blocked = useIsBlocked('food-safety')
  const { venueId, section } = useParams()

  if (blocked) return <PermissionBlockScreen />

  return (
    <Wrapper>
      <H1>Food Safety</H1>
      <BodyText>
        Section logging for <strong>{section}</strong> lands in the next
        Dashboard steps (fast temp entry, then ad-hoc + cleaning).
      </BodyText>
      <BackLink to={`/v/${venueId}/food-safety`}>← Back to today</BackLink>
    </Wrapper>
  )
}

const Wrapper = styled(FadeIn)`
  width: 100%;
  max-width: 42rem;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.md};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`

const BackLink = styled(Link)`
  color: ${({ theme }) => theme.colours.lettuceGreen || '#7cb305'};
  font-weight: 600;
`

export default FoodSafetySectionPlaceholder
